import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mx-auto cmr00100-form-area" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import axios from '../../common/axios-common';
import * as UserAttributeCode from '../../common/code/UserAttributeCode';
import DisplayModeCode from '../../common/code/DisplayModeCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import CautionDialog from '../../components/dialogs/CautionDialog.vue';
import AfiliationInfoForm from '../../components/form/member/AfiliationInfoForm.vue';
import ConfirmationForm from '../../components/form/member/ConfirmationForm.vue';
import UserInfoForm from '../../components/form/member/UserInfoForm.vue';
import ServiceAgreeForm from '../../components/form/ServiceAgreeForm.vue';
import InputFormHeader from '../../components/utils/InputFormHeader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CMR00100',
  setup(__props) {

const router = useRouter();

// ページ(0:ユーザー情報 1:所属先情報 2:登録確認)
const page = ref(0);
// Stepperに表示するタイトル
const titleList = ['ユーザー情報', '所属先情報', '登録確認'];
// アラートダイアログフラグ
const isAlertFlg = ref(false);
// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);
// CautionDialog表示フラグ
const isDisplayCautionDialog = ref(true);
// 会員ID（メールアドレス）エラーフラグ
const isMailAddressErr = ref(false);

// 入力値
const inputData = reactive({
  user_name_sei: '',
  user_name_mei: '',
  mail_address: '',
  mail_address_conf: '',
  user_attribute: UserAttributeCode.default.REAGENT,
  work_school_name: '',
  affiliation_department_name: '',
  postal_cd: '',
  todohuken_name: '',
  street_address: '',
  phone_number: '',
});

// 利用規約・プライバシーポリシーチェック状態
const isAgreeChecked = reactive({
  terms: false,
  policy: false,
});

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * ユーザー情報チェック
 */
const checkUserInfo = async () => {
  const formData = new FormData();
  formData.append('mail_address', inputData.mail_address_conf);

  // ユーザー情報チェック
  await axios
    .post('/cmr001001/check-user', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          isMessageChip.value = false;
          errMessage.value = '';
          isMailAddressErr.value = false;
          // 所属先情報入力画面を表示
          page.value = 1;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.DUPLICATE_EMAIL_ERROR:
            case DetailResultStatusCode.BAN_DOMAIN_ERROR:
            case DetailResultStatusCode.PARAMETER_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              isMailAddressErr.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch(() => {
      // エラー画面に遷移
      router.push({ name: 'error' });
    });
};

/**
 * 会員登録
 */
const registerMember = async () => {
  // Loading Start
  Loading.show();
  // 登録データ作成
  const formData = new FormData();
  formData.append('user_name_sei', inputData.user_name_sei);
  formData.append('user_name_mei', inputData.user_name_mei);
  formData.append('mail_address', inputData.mail_address);
  formData.append('mail_address_conf', inputData.mail_address_conf);
  formData.append('work_school_name', inputData.work_school_name);
  formData.append('affiliation_department_name', inputData.affiliation_department_name);
  formData.append('postal_cd', inputData.postal_cd);
  formData.append('todohuken_name', inputData.todohuken_name);
  formData.append('street_address', inputData.street_address);
  formData.append('phone_number', inputData.phone_number);
  formData.append('user_attribute', inputData.user_attribute);

  // 会員登録
  await axios
    .post('/cmr001002/new-complete', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isAlertFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.BAN_DOMAIN_ERROR:
            case DetailResultStatusCode.DUPLICATE_EMAIL_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
            case DetailResultStatusCode.DELETE_ERROR:
            case DetailResultStatusCode.INSERT_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch(() => {
      // エラー画面に遷移
      router.push({ name: 'error' });
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CautionDialog, { display: isDisplayCautionDialog.value }, null, 8, ["display"]),
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("新規会員登録")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MessageChip, {
        display: isMessageChip.value,
        level: "E",
        message: errMessage.value,
        style: {"margin-top":"-15px"}
      }, null, 8, ["display", "message"]),
      _createVNode(InputFormHeader, {
        list: titleList,
        page: page.value
      }, null, 8, ["page"]),
      _createVNode(_component_q_form, {
        autofocus: "",
        greedy: "",
        novalidate: "",
        onSubmit: _cache[4] || (_cache[4] = ($event: any) => (page.value === 0 ? checkUserInfo() : (page.value += 1))),
        onValidationError: resetError
      }, {
        default: _withCtx(() => [
          (page.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(UserInfoForm, {
                  "member-info": inputData,
                  "is-mail-address-err": isMailAddressErr.value,
                  mode: _unref(DisplayModeCode).REGISTER,
                  onIsMailAddressErr: _cache[0] || (_cache[0] = ($event: any) => (isMailAddressErr.value = $event))
                }, null, 8, ["member-info", "is-mail-address-err", "mode"])
              ]))
            : _createCommentVNode("", true),
          (page.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(AfiliationInfoForm, { "member-info": inputData }, null, 8, ["member-info"])
              ]))
            : _createCommentVNode("", true),
          (page.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(ConfirmationForm, { "member-info": inputData }, null, 8, ["member-info"]),
                _createVNode(ServiceAgreeForm, {
                  class: "q-mt-lg",
                  "is-agree-checked": isAgreeChecked,
                  onTerms: _cache[1] || (_cache[1] = ($event: any) => (isAgreeChecked.terms = $event)),
                  onPolicy: _cache[2] || (_cache[2] = ($event: any) => (isAgreeChecked.policy = $event))
                }, null, 8, ["is-agree-checked"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", null, [
                (page.value === 1 || page.value === 2)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      color: "primary",
                      outline: "",
                      style: {"width":"120px"},
                      class: "q-mr-xs",
                      icon: "mdi-chevron-left",
                      label: "前へ",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (page.value -= 1))
                    }))
                  : _createCommentVNode("", true),
                (page.value === 0)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      type: "submit",
                      color: "primary",
                      outline: "",
                      style: {"width":"120px"},
                      "icon-right": "mdi-chevron-right",
                      label: "次へ"
                    }))
                  : _createCommentVNode("", true),
                (page.value === 1)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 2,
                      type: "submit",
                      color: "primary",
                      outline: "",
                      style: {"width":"120px"},
                      "icon-right": "mdi-chevron-right",
                      label: "次へ"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, [
                  (page.value === 2)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        color: "primary",
                        disabled: isAgreeChecked.terms && isAgreeChecked.policy ? false : true,
                        style: {"width":"120px"},
                        label: "登録",
                        onClick: registerMember
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (isAgreeChecked.terms && isAgreeChecked.policy ? false : true)
                    ? (_openBlock(), _createBlock(_component_q_tooltip, {
                        key: 1,
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [15, 15]
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("strong", null, "会員登録には利用規約・プライバシーポリシーの同意が必要です。", -1)
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AlertDialog, {
        display: isAlertFlg.value,
        level: "information",
        confirmation: "",
        title: "新規会員登録の受付が完了致しました",
        text: [
          'ご登録ありがとうございます。',
          '担当者より折り返しご連絡させていただきますので、今しばらくお待ちくださいますようお願い申し上げます。',
          '2営業日を過ぎても返信がない場合は、メールの送受信に不具合がある可能性がございますので、お手数ですが、お電話にて下記までお問合せください。',
          '',
          'TEL：03-6262-6467',
        ],
        onComplete: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push({ name: 'login' })))
      }, null, 8, ["display"])
    ])
  ]))
}
}

})